import { problemText, type ApiError } from '@/shared/api';

const KNOWN: Record<string, string> = {
  invoice_already_issued: 'Diese Rechnung ist schon ausgestellt.',
  invoice_not_found: 'Diese Rechnung gibt es nicht mehr.',
  invoice_draft_not_found: 'Diesen Entwurf gibt es nicht mehr.',
  invoice_pdf_missing: 'Zu diesem Beleg liegt kein PDF vor.',
  invoice_mail_nothing_to_send: 'Es gibt keinen ausgestellten Beleg zum Versenden.',
  invoice_mail_recipient_missing: 'Für den Versand fehlt die Empfänger-Adresse.',
  invoice_mail_address_invalid: 'Die Empfänger-Adresse ist ungültig.',
};

/** Fehler rund um Rechnungen als deutscher Satz; die fehlenden Absenderangaben nennt der Server selbst. */
export function invoiceErrorText(problem: ApiError): string {
  return problemText(problem, 'Die Aktion ist fehlgeschlagen.', {
    known: KNOWN,
    detailFor: ['financial_issuer_incomplete'],
  });
}
